import Vue from 'vue'
import {Mutation, Action, VuexModule, getModule, Module} from 'vuex-module-decorators'
import store from '../store'
import {CmsApiClient} from "@/_global/api_clients/CmsApiClient";
import {Util} from "@/_global/utils";


@Module({
    name: "SchedulesStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class SchedulesStore extends VuexModule {

    // state
    private _apiResponse: CMS.Schedule[] = [];
    private _scheduleById: { [scheduleId: number]: CMS.Schedule } = {};

    private apiBackup: CMS.Schedule[] = [];
    private edited: { [scheduleId: number]: CMS.Schedule } = {};

    // getter
    get all() {
        return this._apiResponse || [];
    }

    get period() {
        return this._apiResponse.filter(v => v.designated_date == "") || [];
    }

    get day() {
        return this._apiResponse.filter(v => v.designated_date != "") || [];
    }

    get scheduleById() {
        return this._scheduleById || {};
    }

    get dirty(): boolean {
        return Object.keys(this.edited).length > 0;
    }

    @Action
    public async init(menuId: number) {
        const response: CMS.Schedule[] = await CmsApiClient.getSchedules(menuId);
        this.refresh(response);
    }

    @Action
    private refresh(response: CMS.Schedule[]) {
        this.initVals();
        this.setResponse(response);
        for (let i = 0; i < response.length; i++) {
            this.setScheduleById(response[i]);
        }
    }

    @Mutation
    private initVals() {
        this._apiResponse = [];
        this._scheduleById = {};
        this.edited = {};
    }

    @Mutation
    private setResponse(response: CMS.Schedule[]) {
        this._apiResponse = response;
        this.apiBackup = Util.deepCopy(this._apiResponse); //復元用にdeep copyでバックアップ
    }

    @Mutation
    private setScheduleById(schedule: CMS.Schedule) {
        Vue.set(this._scheduleById, schedule.id as number, schedule);
    }

    @Action
    public async create(schedule: CMS.Schedule) {
        await CmsApiClient.createSchedule(schedule);
    }

    @Action
    public async localSort(sortedIds: number[]) {
        // fixme スケジュールはソートなし。落ち着いたら削除
    }

    @Action
    public async applySort() {
        // fixme スケジュールはソートなし。落ち着いたら削除
    }

    @Mutation
    public localEdit(schedule: CMS.Schedule) {
        const scheduleId: number = schedule.id as number;
        if (!this._scheduleById[scheduleId])
            return;

        Vue.set(this._scheduleById, scheduleId, schedule);
        Vue.set(this.edited, scheduleId, schedule);
    }

    @Action
    public async applyEdit() {
        let menuId = -1;
        for (const scheduleId in this.edited) {
            await CmsApiClient.editSchedule(this.edited[scheduleId]);
            menuId = this.edited[scheduleId].menu_id;
        }
        this.init(menuId);
    }

    @Action
    public async cancelEdit() {
        this.refresh(this.apiBackup);
    }

    @Action
    public async delete(scheduleId: number) {
        const target = this.scheduleById[scheduleId];
        const deleted = this._apiResponse.filter(v => v.id != scheduleId);
        this.refresh(deleted);
        await CmsApiClient.deleteSchedule(target);
        this.init(target.menu_id);
    }
}

export default getModule(SchedulesStore)
